import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { IGetOrCreateGoalSegmentResult, IPredicate } from '@feathr/blackbox';
import { CodeBlock } from '@feathr/components';
import { useBlackboxVersion } from '@feathr/extender/hooks';
import { useRole } from '@feathr/report_components';

interface IProps {
  predicates: IPredicate[];
  segmentResult: IGetOrCreateGoalSegmentResult | undefined;
}

function GoalDevConsole({ predicates, segmentResult }: Readonly<IProps>): JSX.Element | null {
  const { isOnProduction } = useBlackboxVersion();
  const { isSuperuser } = useRole();

  if (isOnProduction && !isSuperuser) {
    return null;
  }

  const data = {
    predicates,
    segment: segmentResult
      ? {
          id: segmentResult.segment.id,
          name: segmentResult.segment.get('name'),
          isNew: segmentResult.isNew,
        }
      : null,
  };

  return <CodeBlock code={JSON.stringify(data, null, 2)} language={'json'} />;
}

export default observer(GoalDevConsole);
